import { render, staticRenderFns } from "./TesteView.vue?vue&type=template&id=5047e2e8&scoped=true&"
import script from "./TesteView.vue?vue&type=script&lang=js&"
export * from "./TesteView.vue?vue&type=script&lang=js&"
import style0 from "./TesteView.vue?vue&type=style&index=0&id=5047e2e8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5047e2e8",
  null
  
)

export default component.exports